<template>
  <div class="search_box_container"
  :class="$mq">
    
    <!-- <input type="text" name="search_string" id="search_string" placeholder="Search..."> -->

    <vue-bootstrap-typeahead
	v-model.trim="contest_nomination_text"
	placeholder="Type nomination..."
	:serializer="s => s.label"
	:data="contest_list"
	size="lg"
	inputClass="bod_input_field"
	backgroundVariant="info"
	textVariant="white"
	@hit="emit_hit"
	>
	</vue-bootstrap-typeahead>
    
  </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

export default {
  name: 'search_box',
  props: [
    'contest_list'
  ],
  data () {
    return {
		contest_nomination_text: '',
		suggestions: [
			{
				id: 1,
				nomination_text: 'Test 1'
			},
			{
				id: 2,
				nomination_text: 'Test 2'
			}
		]
	}
  },
  computed: {

  },
  methods: {
    emit_hit: function(hit) {
    	let vm = this;
    	vm.$emit('search_hit', hit);

    	// FIRE GA EVENT
        vm.$ga.event({
          eventCategory: 'Searches',
          eventAction: hit.label,
          eventLabel: 'Search String'
        })
    }
  },
  components: {
    VueBootstrapTypeahead
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.search_box_container {
	background: $dcom-orange;
	padding: 1em 0;
	z-index: 1000;
	width: 100%;
	display: block;

	input {
		display: block;
		flex: none !important;
		width: 90% !important;
		margin: 0 auto;
		padding: 0.4em;
	}

	&.laptop, &.desktop {
		width: 50%;
		left: 50%;
		margin-left: -25%;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/search/search_box.vue